import { render, staticRenderFns } from "./ProjectsListComponent.vue?vue&type=template&id=cf7e4f52&"
import script from "./ProjectsListComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectsListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports